module.exports = __webpack_public_path__ + "static/v1.0.1.3/img/404_txt.a8cf1e41.png";